<template>
  <tr>
    <td
      v-for="(column, index) in columns"
      :key="`td-${invoice.id}-${index}`"
      :class="{
        'sum-cell': isSum
      }"
      :style="`width: ${cellWidth[index]}`"
    >
      <div
        class="relative min-w-[50px] truncate overflow-x-visible"
        :style="`width: ${cellWidth[index]}`"
      >
        <InvoiceRowElement
          :column="column"
          :invoice="invoice"
          :index-invoice="indexInvoice"
          :indexcolumn="index"
          :linked-documents="linkedDocuments && !isSum"
          :class="forceBold ? '!font-bold' : ''"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import InvoiceRowElement from '@c/Dashboard/Content/Invoicing/components/Body/InvoiceRowElement'
import { mapGetters } from 'vuex'

export default {
  name: 'InvoiceRowComponent',
  components: { InvoiceRowElement },
  props: {
    invoice: {
      type: Object,
      required: true
    },
    indexInvoice: {
      type: Number,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    cellWidth: {
      type: Array,
      required: false,
      default: () => []
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    },
    isSum: {
      type: Boolean,
      required: false,
      default: false
    },
    linkedDocuments: {
      type: Boolean,
      required: false,
      default: false
    },
    forceBold: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showTasks: false
    }
  },
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata',
      auth: 'auth/getAuth'
    })
  }
}
</script>
